<script lang="ts">
import { defineComponent as __MACROS_defineComponent } from "vue";
export default /*#__PURE__*/ __MACROS_defineComponent({
  name: 'FormationsSeo'
});
</script>
<template>
  <ka-container
    code="prog-01-seo"
    :data="page.$info.prog01Seo">
    <!-- Page formation -->
    <ka-container code="page-formation">
      <PFormationEntete
        instance-class="p-formation-entete--p50"
        h-1="Formation en SEO" />
      <!-- Container experts -->
      <ka-container code="container-experts">
        <ka-text code="titre">
          <h2 v-html="t('prog01Seo.pageFormation.containerExperts.titre.value', `Nos experts en SEO`)" />
        </ka-text>
        <ka-text code="texte">
          <span v-html="t('prog01Seo.pageFormation.containerExperts.texte.value', `En matière de référencement, Matchers regroupe une communauté d’experts du métier. Toujours en poste, ils sont très opérationnels et axés sur l’efficacité. Le point de départ de nos formations est de faire matcher le profil idéal pour votre besoin. Ensuite, l’expert crée un parcours de formation adapté à votre équipe et votre entreprise. Tout au long de la formation, vous serez guidé et coaché pour faire avancer votre projet.`)" />
        </ka-text>
        <!-- Container -->
        <ka-container code="container">
          <BlocPreviewProfilExpert
            instance-class="test-profils-experts--p50"
            :options="{
              href: `https://www.matchers.fr/expert/261`,
              ariaLabel: `test profils experts`,
              click: page.testProfilsExpertsClick
            }"
            :tags="page.$constants.testProfilsExpertsTags"
            poste="SEO Manager"
            first-name="Jordan"
            enttreprise="&#64;Prestashop"
            image="https://ucarecdn.com/55d9d7ba-d6fd-4d83-bcb4-68c98331a064/" />
          <BlocPreviewProfilExpert
            instance-class="bloc-preview-profil-expert--p50"
            :options="{
              href: `https://www.matchers.fr/expert/241`,
              ariaLabel: `bloc preview profil expert`,
              click: page.blocPreviewProfilExpertClick
            }"
            :xs="{ hidden: null }"
            :tags="page.$constants.blocPreviewProfilExpertTags"
            poste="Trafic manager SEO"
            first-name="Anne-Sophie"
            enttreprise="&#64;Staenk"
            image="https://ucarecdn.com/42ec3356-f493-4ce1-8da4-7729bc86cce1/" />
          <BlocPreviewProfilExpert
            instance-class="element-1--p50"
            :options="{
              href: `https://www.matchers.fr/expert/265`,
              ariaLabel: `bloc preview profil expert`,
              click: page.element1Click
            }"
            :xs="{ hidden: null }"
            :tags="page.$constants.element1Tags"
            poste="SEO manager"
            first-name="Éric"
            enttreprise="&#64;Eskimoz"
            image="https://ucarecdn.com/34fd6d9e-7daa-4171-a7e9-32a4ef280e9e/" />
          <BlocPreviewProfilExpert
            instance-class="element-2--p50"
            :options="{
              href: `https://www.matchers.fr/expert/482`,
              ariaLabel: `bloc preview profil expert`,
              click: page.element2Click
            }"
            :tags="page.$constants.element2Tags"
            poste="Experte en SEO &amp; SEA"
            first-name="Nathalie"
            enttreprise="&#64;Odity"
            image="https://ucarecdn.com/d41ecb08-5f47-48f2-8a0e-bdbb1774b7c0/" />
        </ka-container>
        <ka-text
          code="voir"
          :options="{
            href: `https://www.matchers.fr/experts`,
            ariaLabel: `voir`,
            click: page.voirClick
          }">
          <span v-html="t('prog01Seo.pageFormation.containerExperts.voir.value', `Voir plus de profils >`)" />
        </ka-text>
      </ka-container>
      <!-- Container programme -->
      <ka-container code="container-programme">
        <!-- Container gauche -->
        <ka-container code="container-gauche">
          <!-- Container programme de formation -->
          <ka-container code="container-programme-de-formation">
            <!-- Titre exemple de programme -->
            <ka-container code="titre-exemple-de-programme">
              <ka-text code="voici-un-exemple-de">
                <h2 v-html="t('prog01Seo.pageFormation.containerProgramme.containerGauche.containerProgrammeDeFormation.titreExempleDeProgramme.voiciUnExempleDe.value', `Voici un exemple de programme de formation`)" />
              </ka-text>
              <!-- Container -->
              <ka-container code="container-1" />
            </ka-container>
            <!-- Sections déroulantes -->
            <ka-container code="sections-deroulantes">
              <!-- Conteneur section -->
              <ka-container code="conteneur-section">
                <DropDownFormation
                  instance-class="drop-down-formation--p50"
                  titre="I.   Les bases du référencement"
                  :arguments="page.$constants.dropDownFormationArguments" />
              </ka-container>
              <!-- Conteneur section -->
              <ka-container code="container-2">
                <DropDownFormation
                  instance-class="element-3--p50"
                  titre="II.   Le critère technique"
                  :arguments="page.$constants.element3Arguments" />
              </ka-container>
              <!-- Conteneur section -->
              <ka-container code="container-3">
                <DropDownFormation
                  instance-class="element-4--p50"
                  titre="III.   Le critère éditorial"
                  :arguments="page.$constants.element4Arguments" />
              </ka-container>
              <!-- Conteneur section -->
              <ka-container code="container-4">
                <DropDownFormation
                  instance-class="element-5--p50"
                  titre="IV.   Le critère de popularité"
                  :arguments="page.$constants.element5Arguments" />
              </ka-container>
              <!-- Conteneur section -->
              <ka-container code="container-5">
                <DropDownFormation
                  instance-class="element-6--p50"
                  titre="V.   La préparation SEO d’une refonte de site"
                  :arguments="page.$constants.element6Arguments" />
              </ka-container>
              <!-- Conteneur section -->
              <ka-container code="container-6">
                <DropDownFormation
                  instance-class="element-7--p50"
                  titre="VI.   La mesure de la performance"
                  :arguments="page.$constants.element7Arguments" />
              </ka-container>
            </ka-container>
          </ka-container>
          <CtaProgrammeSurMesurePrendreRdv instance-class="cta-programme-sur-mesure-prendre-rdv--p50" />
        </ka-container>
        <BlocArgCtaRdvPedagogieMatchers
          instance-class="bloc-arg-cta-rdv-pedagogie-matchers--p50"
          :xs="{ hidden: null }"
          expert-1="https://ucarecdn.com/317c648e-e707-43df-8f87-df66b9823bdf/profil_expert_Anne-Sophie.svg" />
      </ka-container>
      <BlocArgPasDeFraisPasDeDemarchesAdministratives instance-class="bloc-arg-pas-de-frais-pas-de-demarches-admi--p50" />
      <PFormationMatching
        instance-class="p-formation-matching--p50"
        description-company="<strong>Bloomin</strong> | Plateforme qui aide les managers &amp; DRH à mesurer et analyser en temps réel l’expérience collaborateur en entreprise.<br> <br><strong>Besoin : </strong>Accroître sa visibilité sur les moteurs de recherche."
        expert-text="<strong>Jordan </strong>| SEO Manager<strong> </strong>| &#64;Prestashop.<br> <br> <br><strong>Expertise : </strong>Travaux sur des dizaines de sites avec des stratégies SEO différentes depuis 2018."
        budget-available="1 600€"
        training-hours="15h"
        support-duration="d’accompagnement à raison de 2h de formation par semaine."
        photo-expert="https://ucarecdn.com/62bdcf48-7bb3-4fa6-a4e0-c7bae7307748/"
        image="https://ucarecdn.com/43ac23b4-43e5-4f61-b5c9-125b22638325/" />
      <BlocReassuranceQualiopi instance-class="bloc-reassurance-qualiopi--p50" />
      <PFormationCriteresQualiopi instance-class="p-formation-criteres-qualiopi--p50" />
      <PFormationPourquoiSeFormer
        instance-class="p-formation-pourquoi-se-former--p50"
        text="<strong>Pourquoi se former en SEO avec Matchers ?</strong>"
        text-1="Notre<strong> formation en SEO</strong> (Search Engine Optimization) est destinée aux entreprises qui souhaitent améliorer leur visibilité en ligne et toucher leur public cible. Selon vos objectifs, le SEO peut être un tremplin pour les atteindre, et ce à moindre coût. " />
    </ka-container>
    <!-- Sections du domaine -->
    <ka-container code="sections-du-domaine">
      <PFormationSectionBleu
        instance-class="p-formation-section-bleu--p50"
        paragraph="En vous formant au SEO, vous pourrez <strong>optimiser votre site Web</strong> pour les moteurs de recherche. Quel que soit votre domaine d’activité, si vous optimisez votre SEO, vous améliorez votre classement dans les résultats de recherche, ce qui conduit à une augmentation du trafic organique de votre site.<br> <br>Trafic orga-quoi ?<br> <br>Le trafic organique correspond au nombre de visiteurs atterrissant sur vos pages issus de clics depuis les pages de résultats sur les moteurs de recherche. Le trafic organique permet de <strong>mesurer l’activité</strong> de son site internet.<br> <br>Une formation sur-mesure en SEO vous pousse à <strong>comprendre le fonctionnement</strong> des algorithmes des moteurs de recherche et les utiliser à votre avantage.<br> "
        title="Vous souhaitez augmenter votre présence en ligne et devenir une référence dans votre domaine ?"
        picture="https://images.unsplash.com/photo-1511296265581-c2450046447d?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3wyOTM3MTZ8MHwxfHNlYXJjaHwxOHx8c2VvfGVufDB8fHx8MTY5MzM5Mjg3NXww&ixlib=rb-4.0.3&q=80&w=1080" />
      <PFormationSectionBanche
        instance-class="p-formation-section-banche--p50"
        paragraph="Il existe <strong>trois grands piliers</strong> du SEO sur lesquels votre site doit être optimisé : le critère éditorial, le critère technique et le critère de notoriété.<br> <br>Il inclut également l’amélioration de la <strong>structure</strong> de votre site, la réduction du <strong>temps de chargement</strong> de votre page et l'amélioration de l'<strong>expérience utilisateur</strong> globale.<br> <br>Ces facteurs contribuent à améliorer l’expérience utilisateur des visiteurs de votre site et les encouragent à rester plus longtemps."
        title="Le SEO ce n’est pas que des mots clés et des balises !"
        picture="https://images.unsplash.com/photo-1599658880436-c61792e70672?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3wyOTM3MTZ8MHwxfHNlYXJjaHw1fHxzZW98ZW58MHx8fHwxNjkzMzkyODc1fDA&ixlib=rb-4.0.3&q=80&w=1080" />
      <PFormationSectionBleu
        instance-class="element-8--p50"
        paragraph="<strong>Vous former en SEO</strong> vous permet de remonter dans les classements des résultats de recherche, et ainsi améliorer votre positionnement par rapport à vos concurrents. Mais pas que !<br> <br>Selon vos objectifs, notre formation en SEO peut également vous permettre de vous <strong>différencier de vos concurrents</strong> en vous apprenant notamment à rédiger de meilleurs contenus, à rendre votre site responsive pour qu’il puisse être lisible sur tous les supports, à optimiser la vitesse de chargement de vos pages…"
        title="L’atout pour défier toute concurrence !"
        picture="https://images.unsplash.com/photo-1554774853-aae0a22c8aa4?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3wyOTM3MTZ8MHwxfHNlYXJjaHwxfHxjb25jdXJyZW50fGVufDB8fHx8MTY5MzM5MjgyNnww&ixlib=rb-4.0.3&q=80&w=1080" />
      <PFormationSectionBanche
        instance-class="element-9--p50"
        paragraph="Vous voilà devenu une référence dans votre domaine ! Votre site apparaît dans les premiers résultats de recherche mais votre taux de conversion reste faible. Le problème : beaucoup d’utilisateurs arrivent sur votre site et ils en sortent aussitôt.<br> <br>Ce phénomène est très contraignant, d’autant plus si votre site est une plateforme e-commerce. Cette donnée peut être analysée, il s’agit du <strong>taux de rebond</strong> !<br> <br>Avoir un bon trafic mais un taux de rebond élevé c’est être assis sur une mine d’or ! Dans ce domaine, nos experts en marketing digital pourront vous partager les meilleurs moyens d’attirer un utilisateur et ne pas perdre son contact."
        title="Augmenter son trafic, c’est bien, le convertir c’est mieux !"
        picture="https://images.unsplash.com/photo-1560472354-b33ff0c44a43?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3wyOTM3MTZ8MHwxfHNlYXJjaHw1fHxnb29nbGUlMjBhbmFseXRpY3N8ZW58MHx8fHwxNjkzMzkyODA4fDA&ixlib=rb-4.0.3&q=80&w=1080" />
    </ka-container>
  </ka-container>
</template>

<route>
{
  "meta": {
    "layout": "Header:Footer"
  }
}
</route>

<script setup lang="ts">
import { generateMeta, syncPageStore } from 'kapix-components-vue3'
import { formationsSeo } from './store'
import BlocArgCtaRdvPedagogieMatchers from '~/components/BlocArgCtaRdvPedagogieMatchers/index.vue'
import BlocArgPasDeFraisPasDeDemarchesAdministratives from '~/components/BlocArgPasDeFrais/PasDeDemarchesAdministratives/index.vue'
import BlocPreviewProfilExpert from '~/components/BlocPreviewProfilExpert/index.vue'
import BlocReassuranceQualiopi from '~/components/BlocReassuranceQualiopi/index.vue'
import CtaProgrammeSurMesurePrendreRdv from '~/components/CtaProgrammeSurMesurePrendreRdv/index.vue'
import DropDownFormation from '~/components/DropDownFormation/index.vue'
import PFormationCriteresQualiopi from '~/components/PFormationCriteresQualiopi/index.vue'
import PFormationEntete from '~/components/PFormationEntete/index.vue'
import PFormationMatching from '~/components/PFormationMatching/index.vue'
import PFormationPourquoiSeFormer from '~/components/PFormationPourquoiSeFormer/index.vue'
import PFormationSectionBanche from '~/components/PFormationSectionBanche/index.vue'
import PFormationSectionBleu from '~/components/PFormationSectionBleu/index.vue'
import { appDataStore } from '~/stores'
import './style.scss'
import './style.custom.scss'


provide('$scoped', '--p50')
const appData = appDataStore()
const page = formationsSeo()
const props = withDefaults(defineProps<{
  seo?: Nullable<boolean>
}>(), {
  seo: true
})

syncPageStore(page)
// SEO
if (props.seo) {
  // https://github.com/vueuse/head
  useHead({
    title: computed(() => page.$title),
    htmlAttrs: { lang: appData.locale },
    meta: computed(() => generateMeta({
      title: page.$title,
      description: page.$description,
      canonicalUrl: appData.hostname,
      publishedTime: page.$publishedTime,
      modifiedTime: page.$modifiedTime,
      ...appData.twitter
    }))
  })

  useSchemaOrg([
    // https://vue-schema-org.netlify.app/api/schema/webpage.html#type-definition
    defineWebPage({
      name: page.$title,
      description: page.$description,
      inLanguage: appData.locale,
      primaryImageOfPage: appData.twitter.image,
      datePublished: page.$publishedTime
      // dateModified: page.$modifiedTime?.toISOString()
    })
  ])
}
</script>
